import { Component } from '@angular/core';
import { DatePipe } from "@angular/common";
import { RouterLink } from "@angular/router";
import { Session } from "../../../services/session.service";

@Component({
  selector: 'app-footer-responsive',
  templateUrl: './footer-responsive.component.html',
  styleUrl: './footer-responsive.component.scss',
  standalone: false
})
export class FooterResponsiveComponent {
  readonly date = new Date();
}
